import React from 'react';
import { Icon } from './Icon';
import cancel from '../icons/cancel.svg';

const FileList = React.memo(({ files = [], onDelete = () => { }, onSetMain = () => { } }) => {
	return (
		<React.Fragment>
			{(files || []).map((file, index) => (
				<div
					key={`fileList-${index}`}
					className={`file-preview btn ${file.isMain ? 'active' : ''}`}
					onClick={() => (file.id ? onSetMain(file.id) : {})}
				>
					<img loading="lazy" alt='file' src={file.file ? URL.createObjectURL(file.file) : file.path} />
					<span className='file-title'>{file.file ? file.file.name : file.path}</span>
					{onDelete && (
						<div
							className='file-delete-block'
							onClick={(e) => {
								e.preventDefault();
								e.stopPropagation();
								onDelete(file);
							}}
						 >
							<Icon name={cancel} />
						</div>
					)}
				</div>
			))}
		</React.Fragment>
	);
});

export default FileList;